import { render, staticRenderFns } from "./product-upload.vue?vue&type=template&id=2e6e0efe&scoped=true"
import script from "./product-upload.vue?vue&type=script&lang=js"
export * from "./product-upload.vue?vue&type=script&lang=js"
import style0 from "./product-upload.vue?vue&type=style&index=0&id=2e6e0efe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6e0efe",
  null
  
)

export default component.exports